import * as React from 'react';

import Modal from 'bundles/internal-ui/components/modal/Modal';

class DeleteMembershipWarningModal extends React.Component<{
  onClickYes: () => void;
  onClosed: () => void;
}> {
  render() {
    return (
      <Modal
        title="Remove Membership"
        onRequestClose={this.props.onClosed}
        open={true}
        actions={[
          {
            text: 'Yes',
            onClick: this.props.onClickYes,
            style: 'danger',
          },
          {
            text: 'No',
            onClick: this.props.onClosed,
            style: 'default',
          },
        ]}
      >
        <span>You are about to remove an enterprise membership for this user. Click &quot;Yes&quot; to proceed</span>
      </Modal>
    );
  }
}

export default DeleteMembershipWarningModal;
